import { render, staticRenderFns } from "./SpeedRoseChart.vue?vue&type=template&id=52793fa6&"
import script from "./SpeedRoseChart.vue?vue&type=script&lang=js&"
export * from "./SpeedRoseChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports